module.exports = __webpack_public_path__ + "img/column_maobi2.8f7d33b6.png";